import { Link } from "react-router-dom"
import { MainLogo } from "../assets/main_logo"
import { isDesktopSize } from "utils/is-desktop";
import { useMediaQuery } from "@/hooks/use-media-query";

export const ServiceTerms = () => {
    const isDesktop = useMediaQuery(isDesktopSize);
    return(
        <>
        <header className="flex flex-col border-b bg-background z-50">

            <div className="flex items-center mx-4 mb-1 md:my-2 lg:px-6 py-2 justify-between">
                <div className="md:w-[30%]">
                    <Link to="/"><div className="flex flex-row items-center lg:ml-8 text-white lg:text-foreground gap-2">
                        {/* <Bot size={48}/> */}
                        <MainLogo color={(isDesktop) ? "#F97316" : "#F97316"} classname="w-12" />
                        <span className={`font-bold mt-3 russo-one-regular ${(isDesktop) ? "logo-text" : "logo-text"}`} >Carri</span></div>
                    </Link>
                </div>
                <div className="flex justify-end gap-2 w-[30%]">
                    <div className="flex flex-col items-center gap-1">
                        
                    </div>
                </div>
            </div>
        </header>
        <main className="max-w-2xl mx-auto px-4 py-8 text-foreground">
            <h1 className="text-2xl font-bold mb-4 text-center">Términos de Servicio de Carriapp</h1>
            <p className="text-sm text-muted-foreground mb-2 text-center">
                Vigente desde: <span className="italic">Mayo 2025</span>
            </p>
            <p className="mb-6">
                Bienvenido a Carriapp. Al usar nuestra plataforma, aceptas los siguientes Términos de Servicio. Por favor, léelos con atención.
            </p>

            <ol className="list-decimal list-inside space-y-4">
                <li>
                    <h2 className="font-semibold mb-1">¿Quiénes somos?</h2>
                    <p>
                        Carriapp es una plataforma digital actualmente en proceso de formalización como empresa en Chile. A través de nuestro sitio web, puedes optimizar tus compras de supermercado distribuyendo tu lista entre distintas tiendas para ahorrar tiempo y dinero.
                    </p>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">¿Qué ofrece Carriapp?</h2>
                    <p>
                        Carriapp es un servicio totalmente gratuito, diseñado para sugerirte la mejor distribución posible de tu lista de compras entre tiendas disponibles. No vendemos productos ni garantizamos la disponibilidad o exactitud de los precios de las tiendas.
                    </p>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">Uso permitido</h2>
                    <ul className="list-disc list-inside ml-4 space-y-1">
                        <li>No utilizarás la plataforma para actividades ilegales.</li>
                        <li>No crearás cuentas falsas o con fines distintos a los del servicio ofrecido.</li>
                        <li>No intentarás robar datos ni alterar el funcionamiento del sistema.</li>
                        <li>Utilizarás el sitio de forma honesta y conforme a su propósito: planificar compras personales.</li>
                    </ul>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">Información referencial</h2>
                    <p>
                        Los precios, productos y condiciones comerciales mostrados son sugerencias referenciales, basadas en la información disponible al momento de armar tu carro. Cada tienda es responsable de sus propios valores y disponibilidad, por lo que Carriapp no se hace responsable de cambios o diferencias en el momento de la compra real.
                    </p>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">Suspensión o eliminación de cuentas</h2>
                    <ul className="list-disc list-inside ml-4 space-y-1">
                        <li>Uso indebido de la plataforma.</li>
                        <li>Violación de estos Términos.</li>
                        <li>Actividades sospechosas que afecten la seguridad o el funcionamiento del sistema.</li>
                    </ul>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">Cambios en los términos</h2>
                    <p>
                        Estos términos pueden actualizarse con el tiempo. Te avisaremos por correo electrónico y mediante una notificación en el sitio si eso ocurre.
                    </p>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">Legislación aplicable</h2>
                    <p>
                        Este servicio se rige por la ley chilena. En caso de conflicto, cualquier disputa será resuelta por los tribunales ordinarios de justicia de Santiago.
                    </p>
                </li>
                <li>
                    <h2 className="font-semibold mb-1">Contacto</h2>
                    <p>
                        ¿Tienes dudas sobre estos términos? Puedes escribirnos a:{" "}
                        <a href="mailto:contacto@carriapp.cl" className="text-primary underline">contacto@carriapp.cl</a>
                        <br />
                        También puedes contactarnos vía <a href="https://wa.me/56989326529" target="_blank" rel="noopener noreferrer" className="text-primary underline">WhatsApp</a>.
                    </p>
                </li>
            </ol>
        </main>
        </>
    )
}